import React, { useMemo, useCallback } from 'react';
import { Select } from 'antd';
import { connect, useDispatch } from 'react-redux';
import { PlatformUtil } from 'utils/platform';
import { ServerAppSettings } from 'utils/server-app-settings';
import { ze } from 'utils/zhEn';
import { push as pushState, replace as replaceState } from 'connected-react-router';
import { generateSearch } from 'utils/helper';
import { PAGE_TYPE_CONVERT } from 'utils/constants';
import { ExceptionCategoryUtil } from 'utils/exception-category';

const options = [{
  label: ze('合并崩溃', 'Merged Crash'),
  value: 1,
  description: ze('统计崩溃和ANR合并数据', 'Crash + ANR Data'),
}, {
  label: ze('原始崩溃', 'Raw Crash'),
  value: 0,
  description: ze('仅统计崩溃数据', 'Only Crash Data'),
}];

const VitalOrCrashSelect = ({
  reduxState,
}) => {
  // 组件废弃，改用VitalOrCrashConfigButton
  return null;

  /*const dispatch = useDispatch();
  const location = reduxState.router.location;

  const currentApp = useMemo(() => reduxState.app.get('current').toJS(), [reduxState.app.get('current')]);
  const { appId, pid } = currentApp;

  const serverAppSettings = reduxState.app.get('appIdToServerAppSettings')[appId] || {};
  //（仅支持ANR的端支持，例如安卓、鸿蒙）莉莉丝需求，是否开启“崩溃+ANR“合并的新指标。（界面上直接取代原来的崩溃指标，可以通过下拉切换原崩溃指标）
  const enableVitalCategory = PlatformUtil.isAnrAvailable(pid) && !!serverAppSettings[ServerAppSettings.keys.enableVitalCategory];

  const searchParams = useMemo(() => reduxState.summary.get('searchParams').toJS(), [reduxState.summary.get('searchParams')]);
  const {
    // 对于开启了vital大类（崩溃+ANR合并统计）的项目，大盘统计各个卡片：true: 查询合并vital指标 false：查询原始crash指标
    // --story=127642761 【CS】【莉莉丝】大盘崩溃统计新增崩溃+ANR合并模式
    isQueryVital,
  } = searchParams;

  const selectOptions = useMemo(() => reduxState.summary.get('selectOptions').toJS(), [reduxState.summary.get('selectOptions')]);
  const {
    pageType,
  } = selectOptions;

  const isViewingCrash = useMemo(() => ExceptionCategoryUtil.isCrash(PAGE_TYPE_CONVERT[pageType]), [pageType]);

  const handleChange = useCallback((v) => {
    // 这边的处理方法跟定义在CrashSightHeader里面的subModuleId选择器一样，触发改变路由之后，由ProductSummaryPage里面的componentDidUpdate来触发后续重新拉取数据
    const query = {
      isQueryVital: !!v,
    };
    dispatch(pushState({
      pathname: location.pathname,
      search: generateSearch(location.search, query),
    }));
  }, [dispatch, location.pathname, location.search]);

  if (!enableVitalCategory || !isViewingCrash) {
    return null;
  }

  return (
    <Select
      style={{ width: '160px' }}
      value={isQueryVital ? 1 : 0}
      onChange={handleChange}
    >
      {options.map(option => (
        <Select.Option key={option.value} value={option.value}>
          <div>
            <div>{option.label}</div>
            <div style={{ fontSize: '12px', color: '#999', lineHeight: '16px' }}>
              {option.description}
            </div>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
  */
};

const mapStateToProps = state => ({
  reduxState: state,
});

export default connect(mapStateToProps)(VitalOrCrashSelect);
